import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

// Suppress ResizeObserver errors - must run BEFORE any other code
(function () {
  const isResizeObserverError = (message) => {
    return (
      message &&
      typeof message === "string" &&
      (message.includes("ResizeObserver loop") ||
        message === "ResizeObserver loop completed with undelivered notifications." ||
        message === "ResizeObserver loop limit exceeded")
    );
  };

  // Capture errors at the earliest possible phase
  window.addEventListener(
    "error",
    (e) => {
      const errorMessage = e.message || e?.error?.message || "";
      if (isResizeObserverError(errorMessage)) {
        console.log("[DEBUG] ResizeObserver error blocked:", errorMessage);
        e.stopImmediatePropagation();
        e.stopPropagation();
        e.preventDefault();
        return false;
      }
    },
    true
  ); // Use capture phase - this runs BEFORE bubble phase

  // Monkey-patch console.error to filter ResizeObserver errors
  const originalConsoleError = console.error;
  console.error = function (...args) {
    const firstArg = args[0];
    if (typeof firstArg === "string" && isResizeObserverError(firstArg)) {
      console.log("[DEBUG] ResizeObserver console.error blocked:", firstArg);
      return; // Don't call original console.error
    }
    return originalConsoleError.apply(console, args);
  };

  // Override window.onerror
  const originalOnError = window.onerror;
  window.onerror = function (message, source, lineno, colno, error) {
    if (isResizeObserverError(message)) {
      console.log("[DEBUG] ResizeObserver window.onerror blocked:", message);
      return true; // Returning true prevents the default error handler
    }
    if (originalOnError) {
      return originalOnError(message, source, lineno, colno, error);
    }
    return false;
  };

  // Handle unhandled rejections
  window.addEventListener(
    "unhandledrejection",
    (e) => {
      const errorMessage = e.reason?.message || e.reason || "";
      if (isResizeObserverError(errorMessage)) {
        console.log("[DEBUG] ResizeObserver unhandledrejection blocked:", errorMessage);
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true
  );

  // As a last resort, hide the webpack error overlay if it appears with ResizeObserver error
  const hideResizeObserverOverlay = () => {
    const iframes = document.querySelectorAll("iframe");
    iframes.forEach((iframe) => {
      try {
        const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
        if (iframeDoc) {
          const body = iframeDoc.body;
          const text = body?.innerText || "";
          if (isResizeObserverError(text)) {
            console.log("[DEBUG] Hiding ResizeObserver error overlay iframe");
            iframe.style.display = "none";
            // Try to close it by simulating ESC key
            const escEvent = new KeyboardEvent("keydown", {
              key: "Escape",
              keyCode: 27,
              which: 27
            });
            iframe.contentWindow?.document.dispatchEvent(escEvent);
          }
        }
      } catch (e) {
        // Cross-origin iframe, ignore
      }
    });

    // Also check for divs with error content (webpack-dev-server overlay)
    const overlays = document.querySelectorAll(
      '[style*="z-index"], [class*="overlay"], [id*="overlay"]'
    );
    overlays.forEach((overlay) => {
      const text = overlay.innerText || overlay.textContent || "";
      if (isResizeObserverError(text)) {
        console.log("[DEBUG] Hiding ResizeObserver error overlay div");
        overlay.style.display = "none";
        overlay.remove();
      }
    });
  };

  // Run the overlay hider periodically
  setInterval(hideResizeObserverOverlay, 100);

  // Also run on DOM changes
  const observer = new MutationObserver(() => {
    hideResizeObserverOverlay();
  });

  // Start observing once DOM is ready
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    window.addEventListener("DOMContentLoaded", () => {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  console.log("[DEBUG] ResizeObserver error suppression initialized");
})();

// import "antd/dist/antd.css";
import "./index.scss";
import "./styles/form.scss";
import "./styles/common.scss";
import "react-phone-input-2/lib/style.css";
import "draft-js/dist/Draft.css";
import App from "./App";
import { store } from "./app/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import * as serviceWorker from "./serviceWorker";
import "antd/dist/antd.less";

let persistor = persistStore(store);

ReactDOM.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  // </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
